import { render, staticRenderFns } from "./FacilitySegment.vue?vue&type=template&id=223fa89e&scoped=true"
import script from "./FacilitySegment.vue?vue&type=script&lang=js"
export * from "./FacilitySegment.vue?vue&type=script&lang=js"
import style0 from "./FacilitySegment.vue?vue&type=style&index=0&id=223fa89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223fa89e",
  null
  
)

export default component.exports